import {
  ADD_EVENT,
  CANCEL_EVENT,
  CURRENT_EVENTS,
  DELETE_EVENT,
  EDIT_EVENT,
  EVENT_DETAILS,
  EVENT_INQUEUE_USERS,
  EVENT_LIST,
  EVENT_TICKET_STATUS,
  GET_LANGUAGE,
  PAST_EVENTS,
  SOLDOUTEVENT,
} from "../../../api/endPoint";
import instance from "../../../helpers/axios";

const normalizeEventPayload = (data = {}) => {
  const payload = {
    ...data,
  };

  if ("is18Plus" in payload) {
    payload.is18plus = !!payload.is18Plus;
    delete payload.is18Plus;
  }

  return payload;
};

const pastEvents = (params = {}) => {
  return instance.get(PAST_EVENTS, { params });
};
const currentEvents = (params = {}) => {
  return instance.get(CURRENT_EVENTS, { params });
};

/** GET /event/list?clubid= — staff offline sale / club event picker */
const eventListByClub = (clubid) => {
  return instance.get(EVENT_LIST, {
    params: { clubid },
  });
};
const addEvent = (data) => {
  return instance.post(ADD_EVENT, normalizeEventPayload(data));
};

const getLanguages = () => {
  return instance.get(GET_LANGUAGE);
};

const soldOutEvent = (data) => {
  return instance.put(`${SOLDOUTEVENT}${data?.id}`, {
    status: data?.status,
  });
};

const updateEvent = (data) => {
  const { id, ...rest } = data;
  return instance.put(`${EDIT_EVENT}${id}`, {
    ...normalizeEventPayload(rest),
  });
};

const getEventDetails = (eventId) =>
  instance.get(`${EVENT_DETAILS}${eventId}`);

const deleteEvent = (id) => {
  return instance.put(`${DELETE_EVENT}${id}`);
};

const cancelEvent = (id) => {
  return instance.put(`${CANCEL_EVENT}${id}`);
};

const ticketStatus = (id, params = {}) => {
  return instance.get(`${EVENT_TICKET_STATUS}${id}`, { params });
};

const inQueueUsers = (id, params = {}) => {
  return instance.get(`${EVENT_INQUEUE_USERS}${id}`, { params });
};

const eventService = {
  pastEvents,
  currentEvents,
  eventListByClub,
  addEvent,
  getLanguages,
  soldOutEvent,
  updateEvent,
  getEventDetails,
  deleteEvent,
  cancelEvent,
  ticketStatus,
  inQueueUsers,
};

export default eventService;
